import { render, staticRenderFns } from "./AccountDashboardDetails.vue?vue&type=template&id=7a5bad72&"
import script from "./AccountDashboardDetails.vue?vue&type=script&lang=ts&"
export * from "./AccountDashboardDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a5bad72')) {
      api.createRecord('7a5bad72', component.options)
    } else {
      api.reload('7a5bad72', component.options)
    }
    module.hot.accept("./AccountDashboardDetails.vue?vue&type=template&id=7a5bad72&", function () {
      api.rerender('7a5bad72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/accounts/accountDashboard/AccountDashboardDetails.vue"
export default component.exports